import { Button, Divider, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import BilanturiTable from './BilanturiTable';


export default class ListaBilanturi extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            bilanturi: [],
            bilant:{},
            openDeleteBilant:false,
            alertView:false
        }
    }




    componentDidMount() {
        this.access()
        this.getData()
    }


    ws = new Ws()
    u = new Utils()
    ls = new LocalStorage().GetUserData()


    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.AccessFinanciar === 1 ? false : true })
        }


    }


    getData = async () => {


        let _getBilanturi =  this.ws.customSelect('select * from fin_import_bilant_head where 1 = 1 and isnull(sters,0) != 1', {
            p1: 1
        })


        let _getClienti =  this.ws.customSelect('select * from fin_import_raport_lunar_clienti_head where 1 = 1 and isnull(sters,0) != 1', {
            p1:1
        })

        let _getBilantRows =  this.ws.customSelect('select * from fin_import_bilant_rows where id_head in (select id from fin_import_bilant_head where isnull(sters,0) != 1)', {
            p2: 1
        })

 


        let [getBilanturi , getClienti, getBilantRows] = await Promise.all([_getBilanturi, _getClienti, _getBilantRows])


        if (getBilanturi.Succes && getClienti.Succes && getBilantRows.Succes ) {

            console.log('getBilanturi :>> ', getBilanturi);
            console.log('getBilantRows :>> ', getBilantRows);

            console.log('getClienti :>> ', getClienti);


            let bilanturi = [...getBilanturi.Content]

            let bRows = [...getBilantRows.Content]

            let clientiH = [...getClienti.Content]



                let clientiRows = await this.ws.customSelect('select * from fin_import_raport_lunar_clienti_rows where id_head in (select id from fin_import_raport_lunar_clienti_head where isnull(sters,0) != 1) and isnull(sters,0) != 1', {
                    p1:clientiH.length > 0 ? clientiH[0].id : ''
                })


                console.log('clientiRows :>> ', clientiRows);

                let bilanturiNew = []
                for(let i = 0 , n = bilanturi.length; i< n ; i++){

                    let idxCifraAfaceri = bRows.findIndex(r => r.id_head === bilanturi[i].id && r.descriere.toLowerCase().includes('cifra de afaceri'))

                    console.log('idxCifraAfaceri :>> ', idxCifraAfaceri);

                   let bilant = bilanturi[i]

                    if(idxCifraAfaceri !== -1){
                        bilant['cifra_afaceri'] = bRows[idxCifraAfaceri]['sold_final']
                    }else{
                        bilant['cifra_afaceri'] = 0
                    }

                    bilanturiNew.push(bilant)
                  

              

                }


                console.log('bilanturiNew :>> ', bilanturiNew);
             
                
                if(clientiRows.Succes){


                    let cRows = [...clientiRows.Content]
                    
                    for(let i = 0 , n = bilanturi.length; i< n ; i++){

                        let idxClienti = clientiH.findIndex(c => c.an === bilanturi[i].an)

                        console.log('idxClienti :>> ', idxClienti);

                        console.log('clientiH :>> ', clientiH);

                        if(idxClienti !== -1){

                            let clientiRows = cRows.filter(c => c.id_head === clientiH[idxClienti].id)

                            console.log('clientiRows :>> ', clientiRows);


                            let clientiUniqueLength = [...new Set(clientiRows.map(c => c.localitate))].length

                            bilanturi[i]['nr_clienti'] = clientiUniqueLength
                        }
                    }

                    this.setState({ bilanturi: bilanturi })

                }





            
        }

    }

    addBilant = () =>{
        this.props.history.push('/bilantnou')
    }


   openDeleteBilant = (b) =>{

        console.log('b :>> ', b);

        this.setState({bilant:b,
                        openDeleteBilant:true})
    }

    deleteBilant = async() =>{

        let _deleteB =  this.ws.update('fin_import_bilant_head', {sters:1}, {id:this.state.bilant.id})

        let _deleteC =  this.ws.update('fin_import_raport_lunar_clienti_head', {sters:1}, {an:this.state.bilant.an })


        let [deleteB, deleteC] = await Promise.all([_deleteB, _deleteC])

        if(deleteB.Succes && deleteC.Succes){

            this.setState({openDeleteBilant:false}, () =>{
                this.getData()

            })
        }
    }

    inapoi = () =>{
        this.props.history.goBack()
    }


    editBilant = (b) =>{

        this.props.history.push(`/datedesprebilant/${b.id}`)
    }
    render() {
        return (
            <div>

                <CustomAppBar history={this.props.history} title='' />


                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />


                <AlertNew
                    open={this.state.openDeleteBilant}
                    dialogClose={()=>{this.setState({openDeleteBilant:false})}}
                    title={'Sunteti sigur ca vreti sa stergeti bilantul selectat ?'}
                    mesaj={'Odata sters, bilantul nu va mai putea fi recuperat !'}
                    yesFunction ={this.deleteBilant}
                    />


                <Grid style={{ maxWidth: 1200, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.financiar.bilanturi} </h1>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            {this.state.bilanturi.length > 0 &&
                                <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>



                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <h5 className='evaluare-noua-subtitlu' style={{ textAlign: 'left', paddingLefft: 20 }} > {this.dictionary.financiar.bilanturiInregistrateInSistem}</h5>


                                        <Divider className='pm-divider' />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>


                                        <BilanturiTable
                                            bilanturi={this.state.bilanturi}
                                            deleteBilant={this.openDeleteBilant}
                                            editBilant={this.editBilant}
                                            dictionary={this.dictionary}
                                        />







                                    </Grid>


                                    <Grid style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-blue'} onClick={this.addBilant}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>add</i>  {this.dictionary.financiar.adaugaBilantNou}
                                        </Button>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'inapoi-button-blue'} onClick={this.inapoi}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                                        </Button>
                                    </Grid>






                                </Grid>
                            }


                            {this.state.bilanturi.length === 0 &&
                                <Grid container>
                                    <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12} >

                                        <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                            <div>
                                                <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i> <span style={{ fontSize: 11, fontWeight: 500 }}>
                                                    {this.dictionary.financiar.bilanturiLength0}</span>
                                            </div>
                                            <div>
                                                <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} className='material-icons'>clear</i>
                                            </div>

                                        </div>


                                    </Grid>

                                    <Grid item style={{ textAlign: 'left', paddingTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'add-button-blue'} onClick={this.addBilant}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>add</i>  {this.dictionary.financiar.adaugaBilantNou}
                                        </Button>

                                        <Button
                                            style={{ marginRight: 20 }}

                                            className={'inapoi-button-blue'} onClick={this.inapoi}  >

                                            <i style={{
                                                fontSize: 14,
                                                marginRight: 10
                                            }} className='material-icons'>keyboard_arrow_left</i>  {this.dictionary.financiar.inapoi}
                                        </Button>

                                    </Grid>
                                </Grid>
                            }
                        </Grid>



                    </Grid>









                </Grid>
            </div>
        );
    }
}